import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/Typography';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import Checkbox from 'Components/UI/Checkbox';
import CheckIcon from '@material-ui/icons/Check';

const styles = (theme) => ({
  root: {
    width: '100%',
    borderRadius: theme.radius.md,
    color: theme.palette.facet.darkGray,
    margin: theme.spacing(0, 0, 1, 0),
    padding: theme.spacing(1, 2),
    justifyContent: 'flex-start',
    '& .MuiCheckbox-root': { // <--- Hides the default radio input
      opacity: 0,
      position: 'fixed',
      width: 0,
    },
  },
  subtleCheckboxRowSelected: {
    width: '100%',
    borderRadius: theme.radius.md,
    color: theme.palette.common.white,
    backgroundColor: theme.palette.facet.primaryBlueMuted,
    transition: 'background-color 0.3s ease-in-out',
  },
  checkboxLabel: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
  },
  formControlLabel: {},
  endIcon: {
    position: 'absolute',
    right: theme.spacing(1.5),
  },
});

const SubtleCheckboxRow = ({
  className,
  classes,
  checked,
  label,
  onChange,
  ...rest
}) => {
  return (
    <FormControlLabel
      className={classNames(classes.root, className, {
        [classes.subtleCheckboxRowSelected]: checked,
      })}
      control={(
        <Checkbox
          checked={checked}
          onChange={onChange}
        />
      )}
      label={(
        <div className={classes.checkboxLabel}>
          <Typography
            className={classes.formControlLabel}
            variant={'h5'}
          >
            {label}
          </Typography>
        </div>
      )}
      {...rest}
    />
  );
};

SubtleCheckboxRow.defaultProps = {
  className: '',
  SelectedEndIcon: CheckIcon,
};

SubtleCheckboxRow.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  checked: PropTypes.bool.isRequired,
  label: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  SelectedEndIcon: PropTypes.object,
};

export default withStyles(styles)(SubtleCheckboxRow);
